import { render } from "./LupaKatalaluan.vue?vue&type=template&id=27ce8e22"
import script from "./LupaKatalaluan.vue?vue&type=script&lang=js"
export * from "./LupaKatalaluan.vue?vue&type=script&lang=js"

import "./LupaKatalaluan.vue?vue&type=style&index=0&id=27ce8e22&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__